const React = require('react');
const {MerchantSelect} = require("../../../../../../../../../InputsHelpers");

module.exports = ({placeholder, propValue, propName, onChange, value, disabled, items}) => {
  return (
    <MerchantSelect
      label={placeholder}
      propValue={propValue}
      propName={propName}
      items={items}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
};
